function createBaseFieldApi(fieldName, formApi) {
  return {
    getField: () => {
      return formApi.getField(fieldName);
    },
    change: (value) => {
      formApi.change(fieldName, value);
    },
    validate: async (force) => {
      const targetField = formApi.getField(fieldName);
      if (force || targetField.status === "indeterminate") {
        await formApi.validate(fieldName);
        return;
      }
      return Promise.resolve();
    },
    setDisabled: (value) => {
      formApi.setFieldDisabledState(fieldName, value);
    },
    setVisible: (value) => {
      formApi.setFieldVisibleState(fieldName, value);
    },
    setRequired: (value) => {
      formApi.setFieldRequiredState(fieldName, value);
    },
    clearValidation: () => {
      formApi.clearValidation(fieldName);
    },
    addValidation: (id, validator) => {
      formApi.addValidation(id, validator, fieldName);
    },
    removeValidation: (id) => {
      formApi.removeValidation(id);
    },
    addMutation: (mutation) => {
      formApi.addFieldMutation(fieldName, mutation);
    },
    removeMutation: () => {
      return formApi.removeFieldMutation(fieldName);
    },
    addTransform: (transform) => {
      formApi.addFieldTransform(fieldName, transform);
    },
    removeTransform: () => {
      return formApi.removeFieldTransform(fieldName);
    }
  };
}
function createArrayFieldApi(fieldName, formApi) {
  return {
    ...createBaseFieldApi(fieldName, formApi),
    changeArrayElement: (index, value) => {
      formApi.changeArrayElement(fieldName, index, value);
    },
    removeArrayElements: (indexes) => {
      formApi.removeArrayElements(fieldName, indexes);
    },
    addArrayElements: (index, element, ...rest) => {
      formApi.addArrayElements(fieldName, index, element, ...rest);
    },
    swapArrayElements: (indexA, indexB) => {
      formApi.swapArrayElements(fieldName, indexA, indexB);
    },
    clearArrayElements: () => {
      formApi.clearArrayElements(fieldName);
    }
  };
}
function createFieldApi(formApi, fieldName) {
  const field = formApi.getField(fieldName);
  if (field.type === "arrayField") {
    const fieldArrayName = fieldName;
    const api = createArrayFieldApi(
      fieldArrayName,
      formApi
    );
    return api;
  }
  return createBaseFieldApi(fieldName, formApi);
}
export {
  createFieldApi
};
//# sourceMappingURL=createFieldApi.js.map
